import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import "./Plans.css";
import { Div, Form, FormGroup, Forms, Label } from './Plans.styles';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import { Checkbox } from 'primereact/checkbox';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CompanyInfo
Description : Formulario de registro y configuración de la empresa
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
29/10/2021 Santiago Coca Rojas Modificación - Se agragan más propiedades a la creación de la compañía
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function Plans(props) {

    /*Propiedades del componente*/
    const [plans, setPlans] = useState({
        ENTITY: localStorage.getItem('entity'),
        CLIENT: localStorage.getItem('client'),
        PAYMENT_PLANS: []
    })

    /*Mensajes informativos*/
    const { info } = useInfo("Plans");

    const [loading1, setLoading1] = useState(false);
    const [loadPage, setLoadPage] = useState(false);

    /*Constantes globales del componente*/
    const { width } = useWindowDimensions()
    const headers = { Authorization: localStorage.getItem("token") }
    const cardStyle = {
        width: "100%", marginBottom: "1rem", justifyContent: "center", display: 'flex',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }

    const toast = useRef(null);

    useEffect(() => {
        getPlans()
    }, [])

    const getPlans = async () => {
        try {
            await apis.getPlans(plans.ENTITY, plans.CLIENT, headers).then(res => {
                const _plans = res.data.PAYMENT_PLANS
                setPlans({
                    ...plans,
                    PAYMENT_PLANS: _plans
                })
                setLoadPage(true)
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const handleClick = (event, label, index) => {
        /*Maneja el estado de la checkbox del formulario del componente*/
        let _plans = plans
        let plan = _plans.PAYMENT_PLANS.find(p => p.LABEL === label)
        // let index = _plans.PAYMENT_PLANS.indexOf(plan)
        plan.VALUE = event === true ? "S" : "N"
        _plans.PAYMENT_PLANS[index] = plan
        setPlans({ ..._plans });
    }

    const putPlans = async () => {
        const _plans = plans
        try {
            await apis.putPlans(_plans, headers).then(res => {
                const newPlans = res.data
                setPlans({ ...newPlans })
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Planes actualizados exitosamente" });
                setLoading1(false)
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            getPlans()
            setLoading1(false)
        }
    }

    /*Renderizado del componente*/
    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container flex-column">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <div className="flex flex-row align-items-center mb-4">
                    <span className="text-900">Planes</span>
                    <Video header="Instructivo proceso configuración datos de la empresa" url={localStorage.getItem('COMPANYINFO_VIDEO')} />
                </div>
            </div>
            <SkeletonTable load={loadPage} width="80vw">
                <div className='flex justify-content-center'>
                    <Tooltip target=".info" className='indigo-tooltip ml-1' />
                    <div style={{ width: '100%' }}>
                        <Card style={cardStyle}>
                            <div className='flex justify-content-center flex-column'>
                                {plans.PAYMENT_PLANS.map((plan, index) =>
                                    <InfoIcon msg={info[index]}
                                        element={
                                            <div className='flex'>
                                                <Checkbox
                                                    inputId="binary"
                                                    checked={plan.VALUE === 'S'}
                                                    disabled={plan.LABEL === 'Estándar'}
                                                    onChange={(e) => handleClick(e.checked, plan.LABEL, index)}
                                                />
                                                <Label htmlFor="label" className='ml-1'>{plan.LABEL}: {plan.DETAIL}</Label>
                                            </div>
                                        } />
                                )}
                            </div>
                        </Card>
                        <div className='mt-6'>
                            <Button label="Guardar" loading={loading1} style={{ marginTop: '-7rem' }} onClick={() => { setLoading1(true); putPlans() }} />
                        </div>
                    </div>
                </div>
            </SkeletonTable>
        </div >
    );
}